export default __webpack_public_path__ + "static/media/MDC.fd19d514.svg";